import config from "config/config";

export const isDeferredAnnuityPlanCode = (policy) => {
  if (!policy || !policy.planAndOptionCode) {
    return false;
  }
  const DEFERRED_ANNUITY_PLAN_CODES =
    config.DEFERRED_ANNUITY_PLAN_CODES?.split(",");
  console.log(DEFERRED_ANNUITY_PLAN_CODES.includes(policy?.planAndOptionCode));

  return DEFERRED_ANNUITY_PLAN_CODES.includes(policy?.planAndOptionCode);
};
